import React, {useEffect, useRef} from 'react';
import {Form, message} from 'antd';
import {ProFormInstance} from '@ant-design/pro-form';
import {FieldProps, WdiModalAppProps, WdiTextArea} from '@/components/WdiControls';
import {ResponseStatus} from '@/utils/request';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {WdiSelectFormat, WdiTreeSelect} from "@/components/WdiControls/WdiSelect";
import {Enum} from "@/enums/system";
import {EC} from "@/services/mdm/ec";
import {WdiInputNumber} from "@/components/WdiControls/WdiInputNumber";
import {FormSp} from "@/services/sales/sp";


type PrePaymentDetailEditAppProps={
  getFormSp: ()=>API.FormSpPreVo
} & WdiModalAppProps

const PrePaymentDetailEditApp: React.FC<PrePaymentDetailEditAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  useEffect(() => {
    const record = props.data?.record;
    formRef.current?.setFieldsValue({
      ecId: record?.ecId,
      amountInVat: record?.amountInVat,
      remark: record?.remark
    })
  }, [props.data]);

  return (
    <>
      <WdiModalForm
        {...HorzLayoutOpts}
        formRef={formRef}
        title={props.title}
        visible={props.visible}
        modalProps={{
          onCancel: () => {
            props.onClose ? props.onClose() : null
          },
          destroyOnClose: true,
          maskClosable: false
        }}
        onFinish={async (values) => {
          const formSpPre = props.getFormSp?.();
          const formSpDetail = {
            ecId: WdiSelectFormat.getvalue(values.ecId),
            amountInVat: values.amountInVat,
            remark: values.remark,
            soldToCode: formSpPre?.soldToCode
          }

          const response = await FormSp.Buttons.validateDetail({
            rowIndex: props.data.rowIndex,
            form: {
              pageTypeId: Enum.PageType.PRE_PAYMENT_THIRD_PART,
              pageGroupId: Enum.PageGroup.PRE_PAYMENT,
              formTypeId: Enum.FormType.PRE_PAYMENT,
              statusId: Enum.FormStatus.AWAITING
            },
            formSp: formSpPre,
            formSpDetail: formSpDetail??[],
            formSpDetails: props.data.formSpDetails
          });
          if (response.code != ResponseStatus.SUCCESS) {
            message.error(response.message);
            return false;
          }
          message.success('保存成功');
          props.onSave?.({
            code: ResponseStatus.SUCCESS,
            data: {
              ...response?.data,
              uid: props.data?.record?.uid
            }
          });
          return true;
        }}
      >
        <Form.Item name="ecId" label="费用项" rules={[{required: true, message: '费用项不能为空!'}]}>
          <WdiTreeSelect {...{
            placeholder: "请选择费用项",
            showSearch: true,
            labelInValue: true,
            dataLoading: async() => {
              return EC.search({
                ecLevels: [ Enum.ECLevel.EC2, Enum.ECLevel.EC3].join(","),
                pageTypeId: Enum.PageType.PRE_PAYMENT_THIRD_PART
              }).then((responseResult) => {
                const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
                  textField: "ecName",
                  valueField: "ecId",
                  id: "ecId",
                  pId: "parentId",
                  level: "ecLevel",
                  disabledLevel: [0,1,2]
                }, responseResult.data);
                return {treeData, dict};
              })
            },
          }} />
        </Form.Item>
        <Form.Item name="amountInVat" label="预付金额" rules={[{required: true, message: '预付金额不能为空!'}]}>
          <WdiInputNumber digits={2} min={0} format='d' />
        </Form.Item>
        <Form.Item name="remark" label="备注" >
          <WdiTextArea />
        </Form.Item>


      </WdiModalForm>
    </>
  );
};
export default PrePaymentDetailEditApp;
